/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CurrentProductListRoutingModule
 * Purpose		: Routing module for CurrentProductList.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CurrentProductListListComponent } from './CurrentProductListList.component';
import { CurrentProductListDetailsComponent } from './CurrentProductListDetails.component';

const CurrentProductListRoutes: Routes = [
	{ path: 'CurrentProductList',  component: CurrentProductListListComponent },
	{ path: 'CurrentProductList/Details/:id', component: CurrentProductListDetailsComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(CurrentProductListRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class CurrentProductListRoutingModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/CurrentProductList/CurrentProductList-routing.module.ts